import { useState } from "react"
import { useMessage } from "hooks/message.hook"
import { useIncludeInProcessing, useObjectsCategories } from "hooks/api/objectsCategories/objectsCategories.hook"

export const CategoriesHandlers = () => {
	const { error: errorMessage } = useMessage()
	const { mutate: includeInProcessingMutate, isPending: isIncludingInProcessingPending } = useIncludeInProcessing()
	const { isRefetching } = useObjectsCategories()
	const [processingCategoryId, setProcessingCategoryId] = useState<number | null>(null)

	// Include category in processing
	const includeInProcessingHandle = (includedInProcessing: boolean, categoryId: number) => {
		setProcessingCategoryId(categoryId)
		includeInProcessingMutate(
			{ includedInProcessing, categoryId },
			{
				onError: () => {
					errorMessage("Something went wrong, please try again later")
					setProcessingCategoryId(null)
				},
				onSettled: () => {
					setProcessingCategoryId(null)
				},
			},
		)
	}

	// Check if specific category is processing
	const isCategoryProcessing = (categoryId: number) => {
		return processingCategoryId === categoryId && (isIncludingInProcessingPending || isRefetching)
	}

	return { includeInProcessingHandle, isCategoryProcessing }
}
